import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M8.308 3.958H6.225c-.92 0-1.667.747-1.667 1.667v8.75c0 .92.746 1.667 1.667 1.667h8.75c.92 0 1.666-.747 1.666-1.667v-2.083m0-4.584v-3.75h-3.75m3.542.209-6.042 6.041" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);